import React from 'react'
import './../assets/table.css'
import moment from 'moment-timezone'
import VerificationTitle from './VerificationTitle'
import VerificationSave from './VerificationSave'
import StandardButtonWithRadio from './StandardButtonWithRadio'
import disabledTicketIcon from '../images/disabledTicketIcon.svg'
import enabledVerticalEventIcon from '../images/enabledVerticalEventIcon.svg'
import disabledRadio from '../images/disabledRadio.svg'
import enabledRadio from '../images/enabledRadio.svg'
import closeIcon from '../images/closeIcon.svg'
import { client } from '../graphql/client'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  getFleetById,
  getTrackableIds
} from '../utils/trackable'
import {
  GET_EVENTS_BY_SELECTED_TICKET,
  UPDATE_EVENT_SELECTED_TO_VALID_STATUS_WITH_VALUE,
  UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITH_VALUE_AND_DELTA
} from '../query/event'
import _ from 'lodash'
import t from 'tcomb-form'
import { getTemplates } from './Templates/templates'
import CircularProgress from '@material-ui/core/CircularProgress'
import Modal from 'react-responsive-modal'
import config from '../config'
moment.locale('fr')

const templates = getTemplates()
const Form = t.form.Form

const FormSchema = t.struct({
  note: t.String
})

const options = {
  fields: {
    note: {
      label: 'Votre commentaire',
      template: templates['note']
    }
  }
}

class TicketVerificationComponent extends React.Component {
  constructor (props) {
    super(props)
    this._isMounted = false
    this.state = {
      value: null,
      reference: 'note',
      disabled: false,
      validEnabledRadio: false,
      invalidEnabledRadio: false,
      invalidEnabledRadioWithDelta: false,
      dataOfSelectedId: null,
      ticketSelected: null,
      selectedEventId: null,
      ticketState: null,
      quantityOfSelectedEvent: null,
      tankCapacity: null,
      openModalForSelectEvent: false,
      openModalForVerificationSelectEvent: false,
      openModalForSubmit: false
    }
  }

  componentDidMount () {
    const self = this
    this._isMounted = true
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token'))
          }
          self.getTicketBySelectedId(self.props.selectedTicketId)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  getTicketBySelectedId (id) {
    const self = this
    fetch(
      `${config.couchdb_final_docs}BySelectedId?key="${id}"`,
      { headers: { 'Access-Control-Allow-Origin': '*' } }
    )
      .then(response => response.json())
      .then((data) => {
        let ticket = data.rows
        self.setState({
          ticketSelected: ticket
        })
        self.getEventsBySelectedTicket(ticket)
      })
      .catch(error => { console.log(error) })
  }

  onSubmit (evt) {
    const self = this
    evt.preventDefault()
    self.setState({
      openModalForSubmit: true
    })
  }

  getDefaultSelectedEvent (ticketSelected, events) {
    let defaultSelectedEvent
    if (ticketSelected && events) {
      events.forEach(function (element) {
        if (moment.utc(element.occurred_at).tz('Indian/Antananarivo').format('DD/MM/YYYY') === moment.utc(ticketSelected[0].value.date_time).tz('Indian/Antananarivo').format('DD/MM/YYYY')) {
          defaultSelectedEvent = element
        }
      })
    }
    return defaultSelectedEvent
  }

  onChange (value) {
    console.log('Value: ', value)
    this.setState({
      value: value
    })
  }

  onClickRow (id, quantity, tankCapacity, occurredAt) {
    const self = this
    var newUtcDate = new Date().toISOString()
    var diffTime = new Date(newUtcDate).getTime() - new Date(occurredAt).getTime()
    var diffDays = diffTime / (1000 * 3600 * 24)
    var eventValidationDayDifference = config.event_validation_day_difference
    if (diffDays <= eventValidationDayDifference) {
      self.setState({
        openModalForVerificationSelectEvent: true
      })
    } else {
      self.setState({
        selectedEventId: id,
        quantityOfSelectedEvent: quantity,
        tankCapacity: tankCapacity
      })
    }
  }

  async getEventsBySelectedTicket (ticket) {
    let self = this
    let fleetId = localStorage.getItem('fleet_id')
    var fleet = await getFleetById(fleetId)
    if (fleet) {
      let trackableIds = fleet.trackables
      let trbImm = self.props.trbImm.replace(/\s/g, '')
      client
        .query({
          query: GET_EVENTS_BY_SELECTED_TICKET,
          variables: { jsonFilter: { 'trb_imm': trbImm }, trackable_ids: getTrackableIds(trackableIds) }
        })
        .then(result => {
          let events = result.data.events
          let defaultSelectedEvent = self.getDefaultSelectedEvent(ticket, events)
          var newUtcDate = new Date().toISOString()
          var diffTime = 0
          if (defaultSelectedEvent) {
            diffTime = new Date(newUtcDate).getTime() - new Date(defaultSelectedEvent.occured_at).getTime()
          }
          var diffDays = diffTime / (1000 * 3600 * 24)
          var eventValidationDayDifference = config.event_validation_day_difference
          if (diffDays <= eventValidationDayDifference) {
            this.setState({
              dataOfSelectedTicket: events
            })
          } else {
            this.setState({
              dataOfSelectedTicket: events,
              selectedEventId: defaultSelectedEvent ? defaultSelectedEvent.id : null,
              quantityOfSelectedEvent: defaultSelectedEvent ? defaultSelectedEvent.value : null,
              tankCapacity: defaultSelectedEvent ? defaultSelectedEvent.metadata.tank_capacity : null
            })
          }
        }).catch(error => console.log(error))
    }
  }

  getDeltaValue (quantityInEvent, tankCapacity) {
    const self = this
    let ticketSelected = self.state.ticketSelected
    if (ticketSelected) {
      let quantityInTicket = ticketSelected[0].value.quantity
      let margin = tankCapacity / 100
      let difference = (quantityInTicket - quantityInEvent).toFixed(2)
      let delta = ((Math.abs(difference) - margin) / margin).toFixed(2)
      if (Math.abs(difference) <= margin) {
        return '-'
      }
      if (difference < 0 && (Math.abs(difference) > margin)) {
        return ('-' + delta + '%')
      }
      if (difference > 0 && (Math.abs(difference) > margin)) {
        return (delta + '%')
      }
    }
  }

  updateToOffenseWithDelta () {
    const self = this
    if (self.state.selectedEventId) {
      self.setState({
        ticketState: self.state.ticketState === 'invalidWithDelta' ? null : 'invalidWithDelta',
        invalidEnabledRadioWithDelta: !self.state.invalidEnabledRadioWithDelta,
        invalidEnabledRadio: false,
        validEnabledRadio: false
      })
    } else {
      self.setState({
        openModalForSelectEvent: true
      })
    }
  }

  updateToChecked () {
    const self = this
    if (self.state.selectedEventId) {
      self.setState({
        ticketState: self.state.ticketState === 'valid' ? null : 'valid',
        validEnabledRadio: !self.state.validEnabledRadio,
        invalidEnabledRadio: false,
        invalidEnabledRadioWithDelta: false
      })
    } else {
      self.setState({
        openModalForSelectEvent: true
      })
    }
  }

  updateToOffense () {
    const self = this
    self.setState({
      ticketState: self.state.ticketState === 'invalid' ? null : 'invalid',
      invalidEnabledRadio: !self.state.invalidEnabledRadio,
      validEnabledRadio: false,
      invalidEnabledRadioWithDelta: false
    })
  }

  onCloseModalForSelectEvent () {
    const self = this
    self.setState({
      openModalForSelectEvent: false
    })
  }

  onCloseModalForVerificationSelectEvent () {
    const self = this
    self.setState({
      openModalForVerificationSelectEvent: false
    })
  }

  onCloseModalForSubmit () {
    const self = this
    self.setState({
      openModalForSubmit: false
    })
  }

  confirmValidation () {
    const self = this
    self.onCloseModalForSubmit()
    self.updateTicketStatus()
  }

  updateEventStatus () {
    const self = this
    let selectedEventId = self.state.selectedEventId
    let selectedTicketId = self.props.selectedTicketId
    let ticketState = self.state.ticketState
    let quantityOfSelectedEvent = self.state.quantityOfSelectedEvent
    let tankCapacity = self.state.tankCapacity
    let delta = self.getDeltaValue(quantityOfSelectedEvent, tankCapacity).replace(/%/g, '')
    if (ticketState === 'valid') {
      client
        .mutate({
          mutation: UPDATE_EVENT_SELECTED_TO_VALID_STATUS_WITH_VALUE,
          variables: { id: selectedEventId, value: { 'ticket_id': selectedTicketId } }
        })
        .then(result => {
          self.props.onClose()
          self.refreshPage()
        }).catch(error => console.log(error))
    }
    if (ticketState === 'invalidWithDelta') {
      client
        .mutate({
          mutation: UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITH_VALUE_AND_DELTA,
          variables: { id: selectedEventId, value: { 'ticket_id': selectedTicketId, 'delta': delta } }
        })
        .then(result => {
          self.props.onClose()
          self.refreshPage()
        }).catch(error => console.log(error))
    }
    if (ticketState === 'invalid') {
      self.props.onClose()
      self.refreshPage()
    }
  }

  updateTicketStatus () {
    const self = this
    var token = localStorage.getItem('token')
    let selectedTicketId = self.props.selectedTicketId
    let selectedEventId = self.state.selectedEventId
    let ticketState = self.state.ticketState
    const value = this.refs[this.state.reference].getValue()
    let attributes
    getUserInfo(token)
      .then(response => response.json())
      .then(function (data) {
        if (data.error && data.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        if (ticketState === 'valid') {
          if (value) {
            attributes = {
              checked: true,
              state: 'valid',
              event_id: selectedEventId,
              notes: value.note
            }
          } else {
            attributes = {
              checked: true,
              state: 'valid',
              event_id: selectedEventId
            }
          }
        }
        if (ticketState === 'invalid') {
          if (value) {
            attributes = {
              has_event: false,
              checked: true,
              state: 'invalid',
              notes: value.note
            }
          } else {
            attributes = {
              has_event: false,
              checked: true,
              state: 'invalid'
            }
          }
        }
        if (ticketState === 'invalidWithDelta') {
          if (value) {
            attributes = {
              checked: true,
              state: 'invalid',
              event_id: selectedEventId,
              notes: value.note
            }
          } else {
            attributes = {
              checked: true,
              state: 'invalid',
              event_id: selectedEventId
            }
          }
        }
        let body = {
          data: {
            type: 'FUEL_SENSOR_TICKET',
            attributes: attributes
          }
        }
        fetch(`${config.couchdb_jsonapi}fuel_sensor_ticket/${selectedTicketId}`, {
          method: 'PUT',
          body: JSON.stringify(body),
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/vnd.api+json'
          }
        }).then(response => {
          response.json()
          self.updateEventStatus()
        }).catch(error => console.log(error))
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  refreshPage () {
    window.location.reload()
  }

  renderLeftContent () {
    let ticketSelected = this.state.ticketSelected
    if (!ticketSelected) {
      return (
        <div style={styles.leftContent}>
          <VerificationTitle
            title='Ticket'
            img={disabledTicketIcon} />
          <div style={styles.section}>
            <CircularProgress style={{ color: '#7ED321', marginTop: '50px', marginLeft: '255px' }} color='inherit' />
          </div>
          <hr style={styles.hr} />
        </div>
      )
    }
    return (
      <div style={styles.leftContent}>
        <VerificationTitle
          title='Ticket'
          img={disabledTicketIcon} />
        <div style={styles.section}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.trHeader}>
                <th style={styles.thContentLeft}>
                  <span style={styles.labelThLeft}>Date</span>
                </th>
                <th style={styles.thContentLeft}>Véhicules</th>
                <th style={styles.thContentLeft}>Volume</th>
                <th style={styles.thContentLeft}>Station service</th>
              </tr>
            </thead>
            <tbody>
              <tr style={styles.trContentLeft}>
                <td className='tdVerificationLeft' style={styles.td}>
                  <span style={styles.labelTdLeft}>{moment.utc(ticketSelected[0].value.date_time).tz('Indian/Antananarivo').format('DD/MM/YYYY')}</span><br />
                  <span style={styles.labelTdLeft}>{moment.utc(ticketSelected[0].value.date_time).tz('Indian/Antananarivo').format('HH:mm:ss')}</span>
                </td>
                <td className='tdVerification' style={styles.td}>{ticketSelected[0].value.vehicle_number}</td>
                <td className='tdVerification' style={styles.td}>{ticketSelected[0].value.quantity.toFixed(2)} Litres</td>
                <td className='tdVerificationRight' style={styles.td}>{ticketSelected[0].value.sale_point}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr style={styles.hr} />
      </div>
    )
  }

  sortDataOfSelectedTicketToDesc () {
    const self = this
    let dataOfSelectedTicket = self.state.dataOfSelectedTicket
    let dataOfSelectedTicketSorted
    if (dataOfSelectedTicket) {
      dataOfSelectedTicketSorted = _.orderBy(dataOfSelectedTicket, function (value) {
        return new Date(value.occurred_at)
      }, 'desc')
    }
    return dataOfSelectedTicketSorted
  }

  renderRightContent () {
    const self = this
    let dataOfSelectedTicket = self.sortDataOfSelectedTicketToDesc()
    if (!dataOfSelectedTicket) {
      return (
        <div style={styles.rightContent}>
          <VerificationTitle
            title='Evénements disponibles'
            img={enabledVerticalEventIcon} />
          <div style={styles.parentSection}>
            <div style={styles.section}>
              <CircularProgress style={{ color: '#7ED321', marginTop: '50px', marginLeft: '360px' }} color='inherit' />
            </div>
          </div>
          <hr style={styles.hr} />
          <div style={styles.contentButtonRight}>
            <StandardButtonWithRadio
              label='DELTA SUPERIEUR'
              onClick={() => self.updateToOffenseWithDelta()}
              enabledRadio={self.state.invalidEnabledRadioWithDelta}
            />
            <StandardButtonWithRadio
              label='CET EVENEMENT EST CONFORME'
              onClick={() => self.updateToChecked()}
              enabledRadio={self.state.validEnabledRadio}
            />
            <StandardButtonWithRadio
              label='AUCUN EVENEMENT A ASSOCIER'
              onClick={() => self.updateToOffense()}
              enabledRadio={self.state.invalidEnabledRadio}
            />
          </div>
        </div>
      )
    }
    return (
      <div style={styles.rightContent}>
        <VerificationTitle
          title='Evénements disponibles'
          img={enabledVerticalEventIcon} />
        <div style={styles.parentSection}>
          <div style={styles.section}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.trHeader}>
                  <th style={styles.myThContentRight} />
                  <th style={styles.thContentRight}>
                    <span style={styles.labelThLeft}>Date</span>
                  </th>
                  <th style={styles.thContentRight}>Véhicules</th>
                  <th style={styles.thContentRight}>Volume</th>
                  <th style={styles.thContentRight}>Station service</th>
                  <th style={styles.myThContentRight}>Delta</th>
                </tr>
              </thead>
              {dataOfSelectedTicket
                ? <tbody>
                  {dataOfSelectedTicket.map((value, key) => {
                    if (value.id === this.state.selectedEventId) {
                      return (
                        <tr
                          key={key}
                          style={styles.trContent}
                          onClick={() => self.onClickRow()}>
                          <td className='tdVerificationLeftSelected' style={styles.tdContentRight}>
                            <img src={enabledRadio} alt='true' />
                          </td>
                          <td className='tdVerificationSelected' style={styles.tdSelected}>
                            <span style={styles.labelTdLeftSelected}>{moment.utc(value.occurred_at).tz('Indian/Antananarivo').format('DD/MM/YYYY')}</span><br />
                            <span style={styles.labelTdLeftSelected}>{moment.utc(value.occurred_at).tz('Indian/Antananarivo').format('HH:mm:ss')}</span>
                          </td>
                          <td className='tdVerificationSelected' style={styles.tdSelected}>{value.metadata.trb_imm}</td>
                          <td className='tdVerificationSelected' style={styles.tdSelected}>{value.value.toFixed(2)} Litres</td>
                          <td className='tdVerificationSelected' style={styles.tdSelected}>-</td>
                          <td className='tdVerificationRightSelected' style={styles.tdSelected}>{self.getDeltaValue(value.value, value.metadata.tank_capacity)}</td>
                        </tr>
                      )
                    }
                    return (
                      <tr
                        key={key}
                        style={styles.trContent}
                        onClick={() => self.onClickRow(value.id, value.value, value.metadata.tank_capacity, value.occurred_at)}
                      >
                        <td className='tdVerificationLeft' style={styles.tdContentRight}>
                          <img src={disabledRadio} alt='true' />
                        </td>
                        <td className='tdVerification' style={styles.td}>
                          <span style={styles.labelTdLeft}>{moment.utc(value.occurred_at).tz('Indian/Antananarivo').format('DD/MM/YYYY')}</span><br />
                          <span style={styles.labelTdLeft}>{moment.utc(value.occurred_at).tz('Indian/Antananarivo').format('HH:mm:ss')}</span>
                        </td>
                        <td className='tdVerification' style={styles.td}>{value.metadata.trb_imm}</td>
                        <td className='tdVerification' style={styles.td}>{value.value.toFixed(2)} Litres</td>
                        <td className='tdVerification' style={styles.td}>-</td>
                        <td className='tdVerificationRight' style={styles.td}>{self.getDeltaValue(value.value, value.metadata.tank_capacity)}</td>
                      </tr>
                    )
                  })}
                </tbody> : null
              }
            </table>
          </div>
        </div>
        <hr style={styles.hr} />
        <div style={styles.contentButtonRight}>
          <StandardButtonWithRadio
            label='DELTA SUPERIEUR'
            onClick={() => self.updateToOffenseWithDelta()}
            enabledRadio={self.state.invalidEnabledRadioWithDelta}
          />
          <StandardButtonWithRadio
            label='CET EVENEMENT EST CONFORME'
            onClick={() => self.updateToChecked()}
            enabledRadio={self.state.validEnabledRadio}
          />
          <StandardButtonWithRadio
            label='AUCUN EVENEMENT A ASSOCIER'
            onClick={() => self.updateToOffense()}
            enabledRadio={self.state.invalidEnabledRadio}
          />
        </div>
      </div>
    )
  }

  renderModalContentForSubmit () {
    const self = this
    let ticketState = self.state.ticketState
    let selectedEventId = self.state.selectedEventId
    if (ticketState !== null) {
      if (ticketState === 'invalid') {
        return (
          <div>
            <h2 style={styles.modalTitleForSubmit}>Modifier état du ticket</h2>
            <p style={styles.modalText}>
              Voulez vous mettre l'état du ticket comme infraction ?
            </p>
            <div>
              <button style={styles.modalButtonLeft} onClick={() => this.onCloseModalForSubmit()}><span>Annuler</span></button>
              <button style={styles.modalButtonRight} onClick={() => this.confirmValidation()}>Modifier</button>
            </div>
          </div>
        )
      } else {
        if (selectedEventId) {
          if (ticketState === 'valid') {
            return (
              <div>
                <h2 style={styles.modalTitleForSubmit}>Modifier état du ticket</h2>
                <p style={styles.modalText}>
                  Voulez vous mettre l'état du ticket comme conforme ?
                </p>
                <div>
                  <button style={styles.modalButtonLeft} onClick={() => this.onCloseModalForSubmit()}><span>Annuler</span></button>
                  <button style={styles.modalButtonRight} onClick={() => this.confirmValidation()}>Modifier</button>
                </div>
              </div>
            )
          }
          return (
            <div>
              <h2 style={styles.modalTitleForSubmit}>Modifier état du ticket</h2>
              <p style={styles.modalText}>
              Voulez vous mettre l'état du ticket comme infraction ?
              </p>
              <div>
                <button style={styles.modalButtonLeft} onClick={() => this.onCloseModalForSubmit()}><span>Annuler</span></button>
                <button style={styles.modalButtonRight} onClick={() => this.confirmValidation()}>Modifier</button>
              </div>
            </div>
          )
        } else {
          return (
            <div>
              <h2 style={styles.modalTitleForSubmit}>Aucun événement sélectionné</h2>
              <div style={styles.buttonContentCenter}>
                <button onClick={() => this.onCloseModalForSubmit()}><span>Fermer</span></button>
              </div>
            </div>
          )
        }
      }
    } else {
      return (
        <div>
          <h2 style={styles.modalTitleForSubmit}>Aucun état sélectionné</h2>
          <div style={styles.buttonContentCenter}>
            <button onClick={() => this.onCloseModalForSubmit()}><span>Fermer</span></button>
          </div>
        </div>
      )
    }
  }

  render () {
    const self = this
    return (
      <div style={styles.container}>
        <div style={styles.contentIcon}>
          <img
            src={closeIcon}
            width='16px'
            height='16px'
            alt='true'
            onClick={self.props.onClose}
          />
        </div>
        <div style={styles.contentTitle}>
          <span style={styles.modalTitle}>VERIFICATION DE TICKET</span>
        </div>
        <div>
          {self.renderLeftContent()}
          {self.renderRightContent()}
        </div>
        <div style={styles.formContent}>
          <form
            onSubmit={(e) => self.onSubmit(e)}>
            <div>
              <div style={styles.fieldContent}>
                <Form
                  ref={this.state.reference}
                  type={FormSchema}
                  options={options}
                  value={this.state.value}
                  onChange={(value) => this.onChange(value)}
                />
              </div>
              <div style={styles.contentButtonSave}>
                <VerificationSave
                  label='VALIDER'
                  type='submit'
                  disabled={this.state.disabled}
                />
              </div>
            </div>
          </form>
        </div>
        <div>
          <Modal
            styles={bg}
            open={this.state.openModalForSelectEvent}
            onClose={() => this.onCloseModalForSelectEvent()}
            showCloseIcon={false}
            focusTrapped={false}>
            <h2 style={styles.modalTitleForSelectEvent}>Aucun événement sélectionné</h2>
            <div style={styles.buttonContentCenter}>
              <button onClick={() => this.onCloseModalForSelectEvent()}><span>Fermer</span></button>
            </div>
          </Modal>
        </div>
        <div>
          <Modal
            styles={bg}
            open={this.state.openModalForSubmit}
            onClose={() => this.onCloseModalForSubmit()}
            showCloseIcon={false}
            focusTrapped={false}>
            {this.renderModalContentForSubmit()}
          </Modal>
        </div>
        <div>
          <Modal
            styles={bg}
            open={this.state.openModalForVerificationSelectEvent}
            onClose={() => this.onCloseModalForVerificationSelectEvent()}
            showCloseIcon={false}
            focusTrapped={false}>
            <p style={styles.modalTitleForSelectEvent}>
              L'événement choisi est trop récent.<br />
              Il est impossible de l'associer à un ticket pour le moment.
            </p>
            <div style={styles.buttonContentCenter}>
              <button onClick={() => this.onCloseModalForVerificationSelectEvent()}><span>Fermer</span></button>
            </div>
          </Modal>
        </div>
      </div>
    )
  }
}

const bg = {
  modal: {
    background: '#364248',
    borderRadius: '6px',
    color: '#F2F2F2'
  }
}

const styles = {
  container: {
    width: '1320px',
    marginTop: '-20px'
  },
  contentIcon: {
    float: 'right',
    cursor: 'pointer'
  },
  contentTitle: {
    marginTop: '20px',
    width: '1180px',
    textAlign: 'center'
  },
  leftContent: {
    float: 'left',
    width: '510px'
  },
  rightContent: {
    float: 'right',
    width: '770px'
  },
  modalTitle: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: '#F2F2F2'
  },
  parentSection: {
    width: '100%',
    overflow: 'hidden'
  },
  section: {
    width: '100%',
    paddingRight: '17px',
    marginTop: '30px',
    height: '402px',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0 16px'
  },
  trHeader: {
    height: '42px'
  },
  thContentLeft: {
    width: '25%',
    textAlign: 'left',
    marginLeft: '82px',
    color: '#A6B9C8',
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  myThContentRight: {
    width: '10%',
    textAlign: 'left',
    marginLeft: '82px',
    color: '#A6B9C8',
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  thContentRight: {
    width: '20%',
    textAlign: 'left',
    marginLeft: '82px',
    color: '#A6B9C8',
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  labelThLeft: {
    marginLeft: '10px',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  trContentLeft: {
    height: '62px',
    marginTop: '12px'
  },
  trContent: {
    cursor: 'pointer',
    height: '62px',
    marginTop: '12px'
  },
  labelTdLeft: {
    marginLeft: '20px',
    color: '#F2F2F2',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  labelTdLeftSelected: {
    marginLeft: '20px',
    color: '#7ED321',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  td: {
    color: '#F2F2F2',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  tdSelected: {
    color: '#7ED321',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  tdContentRight: {
    textAlign: 'center'
  },
  contentButtonRight: {
    float: 'right'
  },
  contentButtonLeft: {
    float: 'left',
    marginLeft: '-12px',
    marginBottom: '36px'
  },
  formContent: {
    width: '100%',
    height: '206px',
    marginTop: '630px'
  },
  fieldContent: {
    float: 'left'
  },
  contentButtonSave: {
    marginTop: '150px',
    float: 'right'
  },
  hr: {
    marginTop: '32px'
  },
  modalTitleForSelectEvent: {
    marginTop: '-10px',
    textAlign: 'center'
  },
  buttonContentCenter: {
    textAlign: 'center'
  },
  modalTitleForSubmit: {
    marginTop: '-10px',
    textAlign: 'center'
  },
  modalText: {
    fontSize: '12px'
  },
  modalButtonLeft: {
    float: 'left',
    width: '100px',
    borderWidth: '0px',
    height: '24px',
    borderRadius: '3px'
  },
  modalButtonRight: {
    borderWidth: '0px',
    float: 'right',
    width: '100px',
    height: '24px',
    borderRadius: '3px'
  }
}

export default TicketVerificationComponent
